export const ItemTypes = {
  QUEUE_EPISODE: "queueEpisode",
};
